import React from "react";
import InnerPageLayout from "../components/Layout/InnerPageLayout";
import BreadCrumb from "../components/Breadcrumb/BreadCrumb";
import AboutCompany from "../components/About/AboutCompany";
import FaqMainOne from "../components/FaqCom/FaqMainOne";
import FunFactCounterTwo from "../components/FunFact/FunFactCounterTwo";


const funFacts = [
  {
    value: 5,
    suffix: "+",
    label: "Countries Global Reach",
    delay: 0,
  },
  {
    value: 2,
    suffix: "+",
    label: "International Awards ",
    delay: 100,
  },
  {
    value: 40,
    suffix: "+",
    label: "Projects Delivered",
    delay: 200,
  }
];

const faqs = [
  {
    question: "Streamline Manual Processes",
    answer:
      "We help you eliminate inefficiencies by automating repetitive manual tasks, improving accuracy, speed, and productivity across your organization.",
  },
  {
    question: "Enhance Scalability",
    answer:
      "Our enterprise technology architectures are designed to grow with your business—ensuring your systems remain flexible, efficient, and ready to handle future demands.",
  },
  {
    question: "Optimize IT Spending",
    answer:
      "We align technology investments with measurable business outcomes, reducing overspend and ensuring every resource delivers real impact.",
  },
  {
    question: "Integrate AI Intelligently",
    answer:
      "We add AI where it makes the most sense, driving innovation and smarter decision-making without disrupting existing processes.",
  },
  {
    question: "Future-Proof Your Business",
    answer:
      "Our solutions are built with long-term sustainability in mind—secure, scalable, and ready to adapt to evolving business and technology needs.",
  },
];

export default function aboutus() {
  return (
    <InnerPageLayout>
      <BreadCrumb pageTitle="About Us" items={[{ label: "About Us", path: "/aboutus" }]} />
      <AboutCompany />
      <FunFactCounterTwo funFacts={funFacts} />
      <FaqMainOne faqs={faqs}/>
    </InnerPageLayout>
  );
}
